// extracted by mini-css-extract-plugin
export default {"text":"Slide_text__K1+gL","image":"Slide_image__zKw2V"};